<template>
  <div class="card">
    <div class="card-header"><i class="icon-refresh"></i> Filtrer</div>
    <div class="card-block">
      <div class="row">
        <div class="form-group col-sm-4">
          <label>Date de début</label>
          <datepicker
            v-model="filters.begin"
            format="dd.MM.yyyy"
            language="fr"
            input-class="form-control"
          ></datepicker>
        </div>

        <div class="form-group col-sm-4">
          <label>Date de début</label>
          <datepicker
            v-model="filters.end"
            format="dd.MM.yyyy"
            language="fr"
            input-class="form-control"
          ></datepicker>
        </div>

        <div class="form-group col-sm-4">
          <label>Société</label>
          <v-select
            :options="merchantOptions"
            v-model="filters.merchant"
          ></v-select>
        </div>
      </div>
    </div>

    <div class="card-footer">
      <button type="button" class="btn btn-sm btn-secondary" @click="apply">
        <i class="icon-eye"></i>&nbsp; Visualiser
      </button>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";

export default {
  components: {
    Datepicker,
    vSelect,
  },

  data() {
    return {
      filters: {
        begin: moment().startOf("month").startOf("day").format("YYYY-MM-DD"),
        end: moment().endOf("month").startOf("day").format("YYYY-MM-DD"),
        merchant: null,
      },
    };
  },

  computed: {
    ...mapState({
      merchants: (state) => state.merchants,
    }),

    merchantOptions() {
      return this.merchants.map((m) => ({
        label: m.name,
        value: m.id,
      }));
    },
  },

  methods: {
    apply() {
      this.$emit("apply", this.filters);
    },
  },
};
</script>
